/* Smooth scroll to the target element */

function initAnchorScroller() {
    const achorLinks = document.querySelectorAll('a[href^="#"]');
    achorLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            handleAnchorScroll(e);
        });
    });
}

function handleAnchorScroll(e) {
    const targetId = e.target.getAttribute('href').slice(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        const headerHeight = document.querySelector('header').offsetHeight || 0;
        const targetPosition = window.scrollY + targetElement.getBoundingClientRect().top - headerHeight;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
}

document.addEventListener('DOMContentLoaded', initAnchorScroller);

/* Global Event Handler Maps */

const globalClickHandlers = new Map([
    ['button[data-action="line-quantity-init"]', e => handleLineQuantityInit(e.target.closest('button[data-action="line-quantity-init"]'), e)],
    ['button[data-action="add-single-item"]', e => handleAddSingleItem(e.target.closest('button[data-action="add-single-item"]'), e)],
    ['button[data-action="init-checkout"]', e => initOfferCheckout(e.target.closest('button[data-action="init-checkout"]'), e)],
    ['button[data-triggers="modal-sequence"][data-disabled="true"]', e => highlightRequiredFields(e.target.closest('button[data-triggers="modal-sequence"][data-disabled="true"]'), e)],
]);

const globalChangeHandlers = new Map([
    ['input[data-action="toggle-line-quantity"]', e => handleLineQuantityToggle(e.target.closest('input[data-action="toggle-line-quantity"]'), e)],
    ['input[data-offer-item-selector]', e => handleItemSelection(e, e.target.closest('[data-offer-section-id]').getAttribute('data-offer-section-id'))],
]);

/* Global Event Listeners */

document.addEventListener('click', (e) => {
    for (const [selector, handler] of globalClickHandlers) {
        if (e.target.closest(selector)) {
            handler(e);
            break;
        }
    }
});

document.addEventListener('change', (e) => {
    for (const [selector, handler] of globalChangeHandlers) { // ✅ use the correct map
        if (e.target.closest(selector)) {
            handler(e);
            break; 
        }
    }
});

document.addEventListener('offerItems:updated', (e) => {
    resolveSelectionUpdate(e.detail.sectionId);
});

document.addEventListener('custom-modal:closed', (e) => {
    handleActiveModalChange(e)
});

document.addEventListener('discountRelevantUpdate', (e) => {
    updateVariantPriceDisplays(e.detail);
    handleDiscountToggleNotices(e.detail);
});

/* Offer Page Functionality */

window.offerGiftItems = {}

// SET WINDOW LEVEL LOOKUP MAP
function parseOfferItemsJson() {
    const productMap = new Map();
    const variantMap = new Map();

    document.querySelectorAll('script[data-offer-product]').forEach(script => {
        try {
            const product = JSON.parse(script.textContent);
            productMap.set(String(product.id), product);
        } catch (e) {
            console.warn('Invalid product JSON:', script, e);
        }
    });

    document.querySelectorAll('script[data-offer-variant]').forEach(script => {
        try {
            const variant = JSON.parse(script.textContent);
            variantMap.set(String(variant.id), variant);
        } catch (e) {
            console.warn('Invalid variant JSON:', script, e);
        }
    });

    // Store or expose the maps if needed
    window.offerLookup = {
        products: productMap,
        variants: variantMap
    };
    document.dispatchEvent(new CustomEvent('offerLookup:ready'));

}

function parseProductTable() {
    const productDataDrops = Array.from(document.querySelectorAll('script[data-products-json]'))
        .map(script => {
            try {
            return JSON.parse(script.textContent);
            } catch (e) {
            console.warn('Invalid JSON in script[data-products-json]', e);
            return null;
            }
        })
        .filter(Boolean) // remove any null/invalid JSON
        .flat(); // flattens if they're arrays

    window.productDataTable = productDataDrops;

    
}

function initRequiredData() {
    parseOfferItemsJson();
    parseProductTable();
}

document.addEventListener('DOMContentLoaded', initRequiredData);

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initRequiredData);
}

document.addEventListener('scroll', handleStickyFooterToggle, { passive: true });
window.addEventListener('resize', handleStickyFooterToggle);
window.addEventListener('load', handleStickyFooterToggle);

// Offer page functionality

// TEMP DISCOUNT REFERENCES

window.customDiscounts = [
    // {
    //     "id": "tablesQty2",
    //     "amount": 5,
    //     "type": "percentage",
    //     "min_item_count": 2,
    //     "max_item_count": 2,
    //     "variant_ids": [46112931938496, 46056789967040],
    //     "primary_item_discount": true,
    //     "line_label": "Two Table Discount (5% Off)"
    // },
    // {
    //     "id": "tablesQty3",
    //     "amount": 10,
    //     "type": "percentage",
    //     "min_item_count": 3,
    //     "max_item_count": 3,
    //     "variant_ids": [46112931938496, 46056789967040],
    //     "primary_item_discount": true,
    //     "line_label": "Three Table Discount (10% Off)"
    // },
    // {
    //     "id": "tablesQty4",
    //     "amount": 15,
    //     "type": "percentage",
    //     "min_item_count": 4,
    //     "variant_ids": [46112931938496, 46056789967040],
    //     "primary_item_discount": true,
    //     "line_label": "4+ Table Discount (15% Off)"
    // },
    {
        "id": "toppersQty2",
        "amount": 4,
        "type": "amount",
        "min_item_count": 2,
        "variant_ids": [46488745935040, 46488745967808],
        "line_label": "Multi Topper Discount"
    }
]

function getLocaleForCurrency(currency) {
    const fallbackLocales = {
        'EUR': 'nl-NL',     // EU
        'GBP': 'en-GB',     // UK
        'CHF': 'de-CH',     // Switzerland
        'NOK': 'nb-NO',     // Norway
        'SEK': 'sv-SE',     // (if needed)
        'HKD': 'zh-HK',     // Hong Kong
        'JPY': 'ja-JP',     // Japan
        'KRW': 'ko-KR',     // South Korea
        'SGD': 'en-SG',     // Singapore
        'AED': 'ar-AE',     // UAE
        'USD': 'en-US',     // US
        'CAD': 'en-CA',     // Canada
        'AUD': 'en-AU',     // Australia
        'NZD': 'en-NZ',     // New Zealand
    };
    return fallbackLocales[currency] || 'en-US';
}

window.currencyLookup = {
    locale: getLocaleForCurrency(Shopify?.currency?.active || 'USD'),
    currency: Shopify?.currency?.active || 'USD',
}

window.formatCurrency = (function () {
    const { locale, currency } = window.currencyLookup;

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return function formatCurrency(amount) {
        return formatter.format(amount);
    };
})();

function isInView(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

async function delay(ms) {
    return await new Promise(resolve => setTimeout(resolve, ms));
}

function parseDiscountsByVariant() {
    const discountMap = {}

    window.customDiscounts.forEach(discount => {
        discount.variant_ids.forEach(variantId => {
            if (!discountMap[variantId]) {
                discountMap[variantId] = [];
            }
            discountMap[variantId].push(discount);
        });
    });

    return discountMap;
}

window.customDiscountsByVariant = parseDiscountsByVariant();

const sumGroup = (group, section) => 
    (section[group] || []).reduce((sum, item) => sum + (item.quantity || 0), 0);

function handleActiveModalChange(e) {
    const activeModal = CustomModal.activeModal;
    if (!activeModal) return;

    const sectionId = activeModal.dataset.offerSectionId || activeModal.getAttribute('modal-id');
    if (!sectionId || !window.selectedItems?.[sectionId]) return;

    const limitActive = activeModal.querySelector('[data-limits="quantity-limited"]') &&
                        !activeModal.querySelector('[data-limits="quantity-limited"][aria-hidden="true"]');
    if (!limitActive) return;

    // Get all unique variant IDs shown in the active modal
    const modalVariantIds = new Set(
        Array.from(activeModal.querySelectorAll('[data-variant-id]'))
            .map(el => el.dataset.variantId)
            .filter(Boolean)
    );

    // Go through all categories in selectedItems and zero out if the variant is in modal
    ['primary', 'multiple_primary', 'accessories'].forEach(key => {
        const group = window.selectedItems[sectionId]?.[key];
        if (!group || !Array.isArray(group)) return;

        group.forEach(item => {
            if (modalVariantIds.has(item.id)) {
                updateItemSelection(key, { id: item.id }, 0, sectionId);
            }
        });
    });
}

function handleStickyFooterToggle() {
    const footer = document.querySelector('[data-content="offer-sticky-footer"]');
    if (!footer) return;

    const toggleParent = document.querySelector('[data-content="offer-primary-cta"]');
    if (!toggleParent) return;

    const globalFooter = document.querySelector('footer');

    const rect = toggleParent.getBoundingClientRect();
    const footerRect = globalFooter.getBoundingClientRect();
    const scrolledPast = rect.bottom < 0;
    const footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;

    footer.classList.toggle('active', scrolledPast && !footerVisible);
    
}

function handleDiscountToggleNotices(detail) {
    if (!window.displayedOneTimeNotices) window.displayedOneTimeNotices = [];
    if (!detail.active_discount) return;

    const noticeId = detail.max_tier 
        ? detail.active_discount.id + '_max' 
        : detail.active_discount.id + '_' + detail.visible_discount.id;

    if (window.displayedOneTimeNotices.includes(noticeId)) return;

    window.displayedOneTimeNotices.push(noticeId);

    const currentDisplayDiscount = detail.active_discount.type === 'percentage' 
        ? detail.active_discount.amount + '%'
        : formatCurrency(detail.active_discount.amount);

    if (!detail.max_tier) {
        const delta = detail.visible_discount.min_item_count - detail.active_discount.min_item_count;
        const deltaDisplay = delta > 1 ? delta : 'one';
        const deltaUnit = delta > 1 ? 'tables' : 'table';
        
        const message = `You're currently receiving ${currentDisplayDiscount} off each table in your order! Add ${deltaDisplay} more ${deltaUnit} to unlock your next discount.`;
        throwNotice(message, 'New Discount Achieved!');
    } else {
        const currentDisplayDiscount = detail.active_discount.type === 'percentage' 
            ? detail.active_discount.amount + '%'
            : formatCurrency(detail.active_discount.amount);
        const message = `You've unlocked the maximum discount! You're currently receiving ${currentDisplayDiscount} on each table in your order.` ;

        throwNotice(message, 'Maximum Discount Enabled!');
    }

}

function handleLineQuantityInit(target, event) {
    const input = target.nextElementSibling instanceof HTMLInputElement 
        ? target.nextElementSibling 
        : target.closest('div').querySelector('input');
    if (!input) return;
    
    updateInputValue(input, input.dataset.defaultValue || 1);
    target.setAttribute('data-active', 'true');
}

function handleAddSingleItem(target, event) {
    const originalText = target.textContent;
    const modal = target.closest('custom-modal');
    target.textContent = 'Adding...';
    target.disabled = true;

    handlePayloadUpdate(target, target.dataset.sectionId);

    setTimeout(() => {
        target.textContent = "Added!";
        target.disabled = false;
    }, 500);

    setTimeout(() => {
        target.textContent = originalText;
        modal.querySelector('button[data-advance-step]').click();
    }, 750);
}

function handleLineQuantityToggle(target, event) {
    handlePayloadUpdate(target, target.dataset.sectionId);
    const value = target.value;
    if (value === '0') {
        const button = target.closest('[data-item="quantity-toggle-set"]')?.querySelector('[data-action="line-quantity-init"]');
        if (button) {
            button.removeAttribute('data-active');
        }

    }
}

function updateInputValue(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
}

function onOfferLookupReady(callback) {
    if (window.offerLookup) {
        callback(window.offerLookup);
    } else {
        document.addEventListener('offerLookup:ready', () => {
            callback(window.offerLookup);
        }, { once: true });
    }
}

function handleItemSelection(event, sectionId) {
    const target = event.target;
    setDiscountState(target, sectionId);
    setMinimumQuantityState(target, sectionId);
    handleModalVisuals(target.id);
    handleDepositDisplayVisibility(target,sectionId);
    handleGiftPairing(target, sectionId);
    toggleModalTriggers(sectionId, target, false);
    setResetItemSelection(sectionId)
    handlePayloadUpdate(target, sectionId);
    updateQuantityLimits(sectionId);
}

function setDiscountState(target, sectionId) {
    const data = target.dataset;
    if (target.dataset.baseDiscount) {
        window.customDiscount = {
            amount: data.baseDiscount,
            type: data.baseDiscountType,
            stacking: data.discountStacking,
            maxApplications: data.maxApplications,
            applicationIteration: data.applicationIteration
        }
        return;
    }
    window.customDiscount = null
}

function handleDepositDisplayVisibility(target, sectionId) {
    const messages = document.querySelectorAll(`[data-deposit-message][data-section-id="${sectionId}"]`);
    messages.forEach(message => {
        message.classList.toggle('hidden', !target.hasAttribute('data-deposit-only'));
    });
}

function updateVariantPriceDisplays(detail) {
    if (!detail) return;

    const sectionId = detail.sectionId;
    const discount = detail.visible_discount || detail.active_discount;
    const updateVariantIds = discount ? discount.variant_ids.map(id => id.toString()) : [];

    const variantPriceDisplays = document.querySelectorAll(`[data-offer-section-id="${sectionId}"][data-content="variant-price-display"]`);

    variantPriceDisplays.forEach(variant => {
        const variantId = variant.dataset.variantId;
        const basePrice = parseFloat(variant.dataset.defaultPrice);

        if (!isNaN(basePrice)) {
            if (updateVariantIds.includes(variantId)) {
                const discounted = applyDiscountToPrice(basePrice, discount);
                variant.textContent = formatCurrency(discounted);
            } else if (variant.textContent !== variant.dataset.defaultPrice) {
                variant.textContent = formatCurrency(variant.dataset.defaultPrice);
            }
        }
    });

    if (!discount) resetVariantPriceDisplays(sectionId);
}

function applyDiscountToPrice(basePrice, discount) {
    if (!discount || typeof basePrice !== 'number') return basePrice;

    let discountedPrice = basePrice;

    if (discount.type === 'percentage') {
        discountedPrice = basePrice * (1 - discount.amount / 100);
    } else if (discount.type === 'amount') {
        discountedPrice = basePrice - discount.amount;
    }

    return Math.max(0, discountedPrice); // Prevent negative pricing
}

function resetVariantPriceDisplays(sectionId) {
    const variants = document.querySelectorAll(`[data-section-id="${sectionId}"][data-content="variant-price-display"]`);
    variants.forEach(variant => {
        variant.textContent = variant.dataset.defaultPrice;
    });
}

function setMinimumQuantityState(target, sectionId) {
    const minimumQuantity = target.dataset.minQuantity ? parseInt(target.dataset.minQuantity) : 1;
    window.activeMinimumQuantity = {}
    window.activeMinimumQuantity[sectionId] = minimumQuantity;

    updateGiftSelectionMax(sectionId);
    const discountTiersState = parsePrimaryDiscounts(null, sectionId);
    document.dispatchEvent(new CustomEvent('discountRelevantUpdate', {
        detail: {
            sectionId,
            visible_discount: discountTiersState.next_tier_discount,
            active_discount: discountTiersState.current_tier_discount,
            max_tier: discountTiersState.isMaxTier,
            first_tier: discountTiersState.isFirstTier,
            next_tier: discountTiersState.isNextTier,
        }
    }));
}

function updateGiftSelectionMax(sectionId) {
    const giftSelectors = document.querySelectorAll(`[data-section-id="${sectionId}"][data-gift-selection="true"]`);
    if (giftSelectors.length === 0) return;

    giftSelectors.forEach(selector => {
        selector.max = selector.dataset.maxQuantity ? parseInt(selector.dataset.maxQuantity) : 1;
    });
}

function toggleGiftSelectorState(sectionId) {
    const giftSelectors = document.querySelectorAll(`[data-section-id="${sectionId}"][data-gift-selection="true"]`);
    if (giftSelectors.length === 0) return;

    const section = window.selectedItems?.[sectionId]
    const selectedGiftCount = sumGroup('gifts', section);
    const primarySelectionCount = sumGroup('primary', section) + sumGroup('multiple_primary', section);

    const maxReached = selectedGiftCount >= primarySelectionCount;

    giftSelectors.forEach(selector => {
        selector.max = primarySelectionCount;
        selector.disabled = maxReached;
        const incrementTrigger = selector.nextElementSibling;
        if (incrementTrigger) {
            incrementTrigger.disabled = maxReached;
        }
    });

    const enablers = document.querySelectorAll(`[data-section-id="${sectionId}"][data-gift-select-enable]`);
    enablers.forEach(enabler => {
        enabler.disabled = maxReached;
    });

    const giftModal = document.querySelector(`custom-modal[data-offer-section-id="${sectionId}"][modal-id="gift-selection"]`);
    if (!giftModal) return;
    const advanceButton = giftModal.querySelector('button[data-advance-step]');
    if (!advanceButton) return;

    advanceButton.disabled = !maxReached;

}

function parsePayloadType(target) {
    if (target.dataset.giftSelection) return 'gifts';
    if (
        target.hasAttribute('data-offer-item-selector') &&
        target.dataset.variantIds &&
        !target.dataset.variantIds.includes(',')
    ) return 'primary';

    if (
        target.hasAttribute('data-offer-item-selector') &&
        target.dataset.variantIds &&
        target.dataset.variantIds.includes(',')
    ) return null;

    if (target.dataset?.action === 'toggle-line-quantity') {
        const variantId = target.dataset.variantId;
        const variant = window.offerLookup.variants.get(variantId);
        if (variant) return 'multiple_primary';
        return 'accessories';
    }

    return 'accessories';
}

function handlePayloadUpdate(target, sectionId) {
    onOfferLookupReady((lookup) => {

        const type = parsePayloadType(target);
        if (!type) return;

        const variantId = target.dataset.variantIds 
            ? target.dataset.variantIds.trim() 
            : target.dataset.variantId;

        if (type === 'primary' || type === 'multiple_primary') {
            const variant = window.offerLookup.variants.get(variantId);
            if (target.dataset.offerPrice) variant.offerPrice = parseFloat(target.dataset.offerPrice);
            const quantity = type === 'primary' 
                ? parseInt(target.dataset.minQuantity, 10) || 1
                : parseInt(target.value, 10)

            if (variant) {
                updateItemSelection(type, variant, quantity, sectionId);
            } else {
                console.warn(`Variant not found for ID: ${variantId}`);
            }
        } else {
            const variant = {
                id: variantId,
                price: target.dataset.variantPrice ? parseInt(target.dataset.variantPrice) : null,
            }
            const quantity = target.value 
                ? parseInt(target.value, 10) 
                : target.dataset.presetQuantity 
                    ? parseInt(target.dataset.presetQuantity, 10) 
                    : 1;

            updateItemSelection(type, variant, quantity, sectionId);
                
        }
    });
}

function setResetItemSelection(sectionId) {
    if (!window.selectedItems) {
        window.selectedItems = {
            [sectionId]: {
                primary: [],
                multiple_primary: [],
                accessories: [],
                gifts: []
            }
        };
    } else {
        window.selectedItems[sectionId] = {
            primary: [],
            multiple_primary: [],
            accessories: [],
            gifts: []
        };
    }
    toggleModalAdvancement(sectionId);
    updateSectionPriceDisplays(sectionId, {total_price: 0, total_compare: 0});
    resetModalSelectionValues(sectionId);
}

function resetModalSelectionValues(sectionId) {
    const resetInputs = document.querySelectorAll(`[data-section-id="${sectionId}"][data-action="toggle-line-quantity"]`);
    const resetButtons = document.querySelectorAll(`[data-section-id="${sectionId}"][data-action="line-quantity-init"]`);
    if (resetInputs.length === 0 && resetButtons.length === 0) return;

    resetInputs.forEach(input => {
        input.value = 0;
    });

    resetButtons.forEach(button => {
        button.removeAttribute('data-active');
    });
}

function updateItemSelection(key, variant, quantity = 1, sectionId = null) {
    const price = variant.offerPrice ? parseFloat(variant.offerPrice) : variant.price * 0.01;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price * 0.01 : variant.price * 0.01;

    const itemPayload = {
        id: variant.id,
        quantity,
        price: key === 'gifts' ? 0 : price,
        comparePrice,
        section: sectionId
    };


    const group = window.selectedItems[sectionId]?.[key];
    if (!Array.isArray(group)) {
        console.warn(`Invalid or missing group for key "${key}"`);
        return;
    }

    switch (key) {
        case 'primary':
            window.selectedItems[sectionId].primary = quantity > 0 ? [itemPayload] : [];
            break;

        case 'multiple_primary': {
            // If setting any multiple_primary, clear primary first
            if (window.selectedItems[sectionId].primary.length > 0) {
                window.selectedItems[sectionId].primary = [];
            }

            const index = group.findIndex(item => item.id === itemPayload.id);
            if (index !== -1) {
                if (quantity === 0) {
                    group.splice(index, 1); // Remove item
                } else {
                    group[index].quantity = quantity;
                }
            } else if (quantity > 0) {
                group.push(itemPayload);
            }
            break;
        }

        case 'accessories': {
            const index = group.findIndex(item => item.id === itemPayload.id);
            if (index !== -1) {
                if (quantity === 0) {
                    group.splice(index, 1); // Remove item
                } else {
                    group[index].quantity = quantity;
                }
            } else if (quantity > 0) {
                group.push(itemPayload);
            }
            break;
        }

        case 'gifts': {
            const index = group.findIndex(item => item.id === itemPayload.id);
            if (index !== -1) {
                group[index].quantity = quantity;
            } else if (quantity > 0) {
                group.push(itemPayload);
            }
            break;
        }

        default:
            console.warn(`Invalid key passed to updateItemSelection: ${key}`);
            break;
    }

    if (key === 'gifts') {
        toggleGiftSelectorState(sectionId);
    }

    document.dispatchEvent(new CustomEvent('offerItems:updated', {
        detail: {
            sectionId
        }
    }));
}


function resolveSelectionUpdate(sectionId) {
    updateSectionPriceDisplays(sectionId, getSectionItemTotals(sectionId));
    handleUpsellReordering(sectionId);
    handleIncludesContent(sectionId);
    toggleModalAdvancement(sectionId);
}

function parsePrimarySelectedQuantity(sectionId) {
        const section = window.selectedItems?.[sectionId];
        if (!section) return 0;
    
        return sumGroup('primary', section) + sumGroup('multiple_primary', section);
}

function toggleModalAdvancement(sectionId) {
    const modals = document.querySelectorAll(`custom-modal[data-offer-section-id="${sectionId}"]`);
    if (modals.length === 0) return;

    modals.forEach(modal => {
        const isPrimary = modal.hasAttribute('data-primary-item-selection');
        if (isPrimary) {
            togglePrimaryModalAdvancement(modal, sectionId);
        } else {
            toggleAdvanceState(modal);
        }
    })
}

function togglePrimaryModalAdvancement(modal, sectionId) {
    const primaryInput = modal.querySelector('input[type="number"]');
    if (!primaryInput) return;
    

    const advanceButton = modal.querySelector('button[data-advance-step]');
    if (!advanceButton) return;

    const currentQuantity = parsePrimarySelectedQuantity(sectionId);

    const advance = currentQuantity >= window.activeMinimumQuantity[sectionId];

    advanceButton.disabled = !advance;
    advanceButton.textContent = advance 
        ? advanceButton.dataset.defaultText 
        : `Add ${window.activeMinimumQuantity[sectionId] - currentQuantity} More to Continue`;
}

function toggleAdvanceState(modal) {
    const advanceButton = modal.querySelector('button[data-advance-step]');
    if (!advanceButton) return;

    const unlimited = modal.querySelectorAll('[data-limits="quantity-limited"]').length === 0 || modal.querySelector('[data-limits="quantity-limited"][aria-hidden="true"]') ? true : false;
    if (!unlimited) return;

    const button = modal.querySelector('[data-advance-step]');
    if (!button) return;
    const selected = parseModalQuantities(modal);

    button.textContent = selected > 0 ? button.dataset.defaultText : button.dataset.inactiveContent;
}

function parseModalQuantities(modal) {
    return Array.from(modal.querySelectorAll('input[type="number"]'))
        .map(input => parseFloat(input.value) || 0)
        .reduce((sum, val) => sum + val, 0);    
}

function findSelectedPrimaryItem(sectionId, titleHandle = 'relic') {
    const selected = window.selectedItems?.[sectionId];
    const lookup = window.offerLookup;

    if (!selected || !lookup) return false;

    const getProductByVariantId = (variantId) => {
        for (const product of lookup.products.values()) {
            const match = product.variants.find(v => String(v.id) === String(variantId));
            if (match) return product;
        }
        console.warn(`⚠️ Product not found for variant ID: ${variantId}`);
        return null;
    };

    const checkGroup = (group) => {
        return (selected[group] || []).some(item => {
            const product = getProductByVariantId(item.id);
            return product?.title?.toLowerCase().includes(titleHandle);
        });
    };

    return checkGroup('primary') || checkGroup('multiple_primary');
}

function handleUpsellReordering(sectionId) {
    const upsellItems = document.querySelectorAll(`[data-upsell-type][data-offer-section-id="${sectionId}"]`);
    if (upsellItems.length === 0) return;

    const hasRelic = findSelectedPrimaryItem(sectionId);
    const primaryIndices = hasRelic 
        ? {
            'relic': 0,
            'hexlite': 100,
            'universal': 200
        }
        : {
            'hexlite': 0,
            'relic': 100,
            'universal': 200
        }
    
    const secondaryIndices = {
        'universal': 0,
        'hexlite': 0,
        'relic': 0
    }

    upsellItems.forEach(item => {
        const type = item.dataset.upsellType || 'universal';
        const currentIndex = primaryIndices[type] + secondaryIndices[type];
        item.style.order = currentIndex;
        secondaryIndices[type]++;
    });
}

function handleIncludesContent(sectionId) {
    const includesContent = document.querySelectorAll(`[data-content="includes-display-content"][data-offer-section-id="${sectionId}"]`);
    if (includesContent.length === 0) return;
    
    const relicSelected = findSelectedPrimaryItem(sectionId, 'relic');
    const hexliteSelected = findSelectedPrimaryItem(sectionId, 'hexlite');

    const selectionType = relicSelected && hexliteSelected ? 'mixed' : relicSelected ? 'relic' : 'hexlite';

    includesContent.forEach(content => {
        const typeMatch = content.dataset.includesFor === selectionType;
        content.classList.toggle('hidden', !typeMatch);
    });
    
}

function updateQuantityLimits(sectionId) {
    const selection = window.selectedItems?.[sectionId]?.primary || [];
    const limitActive = selection.length === 1;

    const conditionalCtas = document.querySelectorAll(`[data-section-id="${sectionId}"][data-limits]`);
    if (conditionalCtas.length === 0) return;

    conditionalCtas.forEach(toggle => {
        const isUnlimited = toggle.dataset.limits.includes('unlimited');
        const shouldShow = isUnlimited ? !limitActive : limitActive;
        toggle.classList.toggle('hidden', !shouldShow);
        toggle.setAttribute('aria-hidden', !shouldShow);
    });
}

function updateSectionPriceDisplays(sectionId, totals) {
    const localTotals = {
        total_price: formatCurrency(totals.total_price),
        total_compare: formatCurrency(totals.total_compare)
    };
    const priceDisplays = document.querySelectorAll(`[data-content="offer-selection-subtotal"][data-section-id="${sectionId}"]`);
    const comparePriceDisplays = document.querySelectorAll(`[data-content="offer-selection-subtotal-compare"][data-section-id="${sectionId}"]`);

    priceDisplays.forEach(display => {
        display.textContent = localTotals.total_price;
    });

    comparePriceDisplays.forEach(display => {
        display.classList.toggle('hidden', localTotals.total_price === localTotals.total_compare);
        display.textContent = localTotals.total_compare;
    });
}

function getSectionItemTotals(sectionId) {
    const selected = window.selectedItems?.[sectionId];
    const gifts = window.offerGiftItems?.[sectionId] || [];
    const discounts = window.customDiscounts || [];

    if (!selected) return { total_price: 0, total_compare: 0 };

    let total_price = 0;
    let total_compare = 0;

    const allItems = ['primary', 'multiple_primary', 'accessories', 'gifts']
        .flatMap(key => selected[key] || []);

    const variantQtyMap = {};
    allItems.forEach(item => {
        variantQtyMap[item.id] = (variantQtyMap[item.id] || 0) + item.quantity;
    });

    const applicableDiscounts = [];

    for (const discount of discounts) {
        const totalMatchingQty = discount.variant_ids.reduce((sum, variantId) => {
            return sum + (variantQtyMap[variantId] || 0);
        }, 0);

        const meetsMin = totalMatchingQty >= discount.min_item_count;
        const meetsMax = discount.max_item_count ? totalMatchingQty <= discount.max_item_count : true;

        if (meetsMin && meetsMax) {
            applicableDiscounts.push(discount);
        }
    }

    parseApplicableDiscountState(applicableDiscounts, sectionId);

    const variantDiscountMap = {};

    for (const discount of applicableDiscounts) {
        for (const variantId of discount.variant_ids) {
            if (!variantDiscountMap[variantId]) variantDiscountMap[variantId] = [];
            variantDiscountMap[variantId].push(discount);
        }
    }

    const isCurrencyUSD = (Shopify?.currency?.active || 'USD') === 'USD';

    allItems.forEach(item => {
        const itemQty = item.quantity;
        const basePrice = item.price;
        const discounts = variantDiscountMap[item.id] || [];

        let linePrice = basePrice;

        for (const discount of discounts) {
            if (discount.type === 'percentage') {
                linePrice *= (1 - discount.amount / 100);
            } else if (discount.type === 'amount') {
                if (isCurrencyUSD) {
                    linePrice = Math.max(0, linePrice - discount.amount);
                } else {
                    // Convert amount → percentage using variant USD price
                    const variant = window.offerLookup?.variants.get(String(item.id));
                    if (variant?.price) {
                        const usdBase = variant.price / 100;
                        const percent = (discount.amount / usdBase) * 100;
                        linePrice *= (1 - percent / 100);
                    }
                }
            }
        }

        total_price += linePrice * itemQty;
        total_compare += item.comparePrice * itemQty;
    });

    gifts.forEach(gift => {
        if (!gift.inventory_item) {
            total_compare += gift.value;
        }
    });

    return { total_price, total_compare };
}


function parsePrimaryDiscounts(activePrimaryDiscount, sectionId) {
    const allDiscounts = window.customDiscountsByVariant;
    const primaryDiscounts = Object.values(allDiscounts)
        .flat()
        .filter(d => d.primary_item_discount);

    if (primaryDiscounts.length === 0 ) {
        return {
            next_tier_discount: null,
            current_tier_discount: null,
            isFirstTier: false,
            isNextTier: false,
            quantityNeeded: null,
            isMaxTier: false,
        };
    }

    const sortedDiscounts = [...new Set(primaryDiscounts)].sort((a, b) => a.min_item_count - b.min_item_count);

    // ✅ Fallback: no active discount, but section-level activeMinimumQuantity is set
    const sectionMinimumQty = window.activeMinimumQuantity?.[sectionId];

    if (!activePrimaryDiscount && sectionMinimumQty != null) {
        const matchedTier = sortedDiscounts.find(d => d.min_item_count === sectionMinimumQty);

        return {
            next_tier_discount: matchedTier || null,
            current_tier_discount: null,
            isFirstTier: true,
            isNextTier: false,
            isMaxTier: primaryDiscounts.length > 1 ? false : true,
            quantityNeeded: matchedTier ? matchedTier.min_item_count : null,
        };
    }

    // ✅ Normal next-tier logic
    if (activePrimaryDiscount) {
        const currentQty = activePrimaryDiscount.min_item_count;

        const nextTier = sortedDiscounts.find(d =>
            d.id !== activePrimaryDiscount.id &&
            d.min_item_count > currentQty
        );

        return {
            next_tier_discount: nextTier,
            current_tier_discount: activePrimaryDiscount,
            isFirstTier: false,
            isNextTier: !!nextTier,
            isMaxTier: !nextTier && activePrimaryDiscount ? true : false,
            quantityNeeded: nextTier ? nextTier.min_item_count - currentQty : null,
        };
    }

    // ✅ Fallback if neither condition matched
    return {
        next_tier_discount: null,
        current_tier_discount: null,
        isFirstTier: false,
        isNextTier: false,
        quantityNeeded: null,
    };
}


function parseApplicableDiscountState(applicableDiscounts, sectionId) {
    const discountMap = window.customDiscountsByVariant;
    const activePrimaryDiscount = applicableDiscounts.find(discount => discount.primary_item_discount);
    const discountTiersState = parsePrimaryDiscounts(activePrimaryDiscount, sectionId);
    
    document.dispatchEvent(new CustomEvent('discountRelevantUpdate', {
        detail: {
            sectionId,
            visible_discount: discountTiersState.next_tier_discount,
            active_discount: discountTiersState.current_tier_discount,
            max_tier: discountTiersState.isMaxTier,
            first_tier: discountTiersState.isFirstTier,
            next_tier: discountTiersState.isNextTier,
        }
    }));
}

function handleGiftPairing(target, sectionId) {
    const giftDisplays = document.querySelectorAll(`[data-content="gift-display-list"][data-offer-section-id="${sectionId}"]`);
    if (giftDisplays.length === 0) return;

    const currentQuantity = target.dataset.minQuantity ? parseInt(target.dataset.minQuantity) : 1;
    let currentUnlockedCount;
    giftDisplays.forEach(display => {
        const unlockedCount = updateGiftsetDisplay(display, currentQuantity);
        if (!currentUnlockedCount) currentUnlockedCount = unlockedCount;
    })

    updateGiftDisplayCounts(sectionId, currentUnlockedCount);
}

function updateGiftsetDisplay(group, currentQuantity) {
    const sectionId = group.dataset.offerSectionId || null;
    if (sectionId && !window.offerGiftItems[sectionId]) {
        window.offerGiftItems[sectionId] = []
    }

    const displayedGifts = group.querySelectorAll('[data-content="gift-display-item"]');
    let unlockedCount = 0;
    if (displayedGifts.length === 0) return 0;

    displayedGifts.forEach(gift => {
        const giftQualifier = gift.dataset.qualifierMin ? parseInt(gift.dataset.qualifierMin) : 1;
        const active = currentQuantity >= giftQualifier;
        gift.setAttribute('data-active', active);
        if (active) { 
            const exists = window.offerGiftItems[sectionId].find(item => item.title === gift.dataset.giftTitle);
            if (!exists) {
                const giftJson = { 
                    "title": gift.dataset.giftTitle,
                    "value": gift.dataset.giftValue ? parseInt(gift.dataset.giftValue, 10) : null
                }
                if (gift.dataset.inventoryGift) giftJson.inventory_item = true;
                window.offerGiftItems[sectionId].push(giftJson)
            }
            unlockedCount++ 
        };
    })

    return unlockedCount;
}

function updateUnlockedCounts(sectionId, currentQuantity) {
    const countDisplays = document.querySelectorAll(`[data-content="unlocked-gift-count"][data-offer-section-id="${sectionId}"]`);
    if (countDisplays.length === 0) return;
    
    countDisplays.forEach(countDisplay => {
        countDisplay.textContent = currentQuantity;
    });
}

function findModalByMid(modalId) {
    return document.querySelector(`[modal-id="${modalId}"]`) ? true : false;
}

function determineNextAvailableStep() {
    const steps = ['gift', 'extender', 'accessory'];
    for (const step of steps) {
        const modalExists = findModalByMid(`${step}-selection`);
        if (modalExists) {
            return step;
        }
    };
    return null;
}

function toggleModalTriggers(sectionId, target, disabled = false) {
    const targetQty = target.dataset.minQuantity ? parseInt(target.dataset.minQuantity) : 1;

    const buttons = document.querySelectorAll(`[data-triggers="modal-sequence"][data-selector-for="${sectionId}"]`);
    if (buttons.length === 0) return;

    buttons.forEach(button => {
        //button.disabled = disabled;
        button.setAttribute('data-disabled', disabled);
        const fallback = determineNextAvailableStep();
        const variable = targetQty > 1 ? 'table' : fallback;

        if (variable) {
            button.setAttribute('data-modal-id', `${variable}-selection`);
            button.setAttribute('aria-controls', `${variable}-selection-modal`);
        } else {
            // TODO: Update button to handle checkout toggle
            // Not possible today, but should future-proof when time allows. Also adding this note for other devs down the line. 
        }
    });
}

function updateGiftDisplayCounts(sectionId, value) {
    const countDisplays = document.querySelectorAll(`[data-content="unlocked-gift-count"][data-offer-section-id="${sectionId}"]`);
    if (countDisplays.length === 0) return;
    
    countDisplays.forEach(countDisplay => {
        countDisplay.textContent = value;
    });
}

function handleModalVisuals(id) {
    const modalImages = document.querySelectorAll('[data-modal-image="true"]');
    if (modalImages.length === 0) return;
    
    const matchId = id.replace('op-radio-', 'op-modal-image-');
    modalImages.forEach(image => {
        image.classList.toggle('hidden', image.getAttribute('data-content') !== matchId);
    });
}

function parseSummaryProperties(items) {
    const props = {};
    items.forEach((item, index) => {
        const variantId = typeof item.id === 'string' ? parseInt(item.id, 10) : item.id;
        const product = window.productDataTable.find(p =>
            p.variants.some(v => v.id === variantId)
        );
        if (!product) {
            props[`Reserved Item ${index + 1}`] = `(1) Unknown Product (ID: ${item.id})`;
            return;
        }
    
        const variant = product.variants.find(v => v.id === variantId);
        const quantity = item.quantity || 1;
        const productTitle = product.title;
        const variantTitle = variant.title && variant.title !== "Default Title" ? ` - ${variant.title}` : '';
        const includes = item.properties?.Includes || item.properties?.includes;
        const includesText = includes ? `: With ${includes}` : '';
        const giftNote = item.properties?._gift === true ? ` (FREE Gift with Reservation 🎁)` : '';
    
        props[`Reserved Item ${index + 1}`] = `(${quantity}) ${productTitle}${variantTitle}${includesText}${giftNote}`;
    });
  
    return props;

}

function parseVariatedDiscountSets() {
    const uniqueKeys = new Set();
  
    for (const discount of window.customDiscounts) {
        const key = discount.variant_ids
            .map(String)
            .sort()
            .join(','); // normalize and stringify
    
        uniqueKeys.add(key); // ensures deduplication
    }
  
    // Convert keys back to arrays of numbers
    return Array.from(uniqueKeys).map(key => key.split(',').map(Number));
}

function parseCustomDiscounts(items) {
    const discountSets = parseVariatedDiscountSets();
  
    discountSets.forEach(set => {
      const setItems = items.filter(item =>
        set.includes(Number(item.id)) && !item.properties?._gift
      );
  
      const totalQuantity = setItems.reduce((sum, item) => sum + item.quantity, 0);
      if (totalQuantity === 0) return;
  
      const applicableDiscounts = window.customDiscounts.filter(
        d =>
          d.variant_ids.length === set.length &&
          d.variant_ids.every(id => set.includes(id)) &&
          (d.min_item_count <= totalQuantity || !d.min_item_count) &&
          (d.max_item_count >= totalQuantity || !d.max_item_count)
      );
  
      if (applicableDiscounts.length === 0) return;
  
      const bestDiscount = applicableDiscounts.reduce((best, curr) =>
        !best || curr.amount > best.amount ? curr : best,
      null);
  
      if (!bestDiscount) return;
  
      setItems.forEach(item => {
        const product = window.productDataTable.find(p =>
          p.variants.some(v => v.id.toString() === item.id.toString())
        );
        const variant = product?.variants.find(v => v.id.toString() === item.id.toString());
        const fullPrice = variant ? variant.price * 0.01 : 0;
  
        const discountPrice = bestDiscount.type === 'percentage'
          ? parseFloat((fullPrice * ((100 - bestDiscount.amount) / 100)).toFixed(2))
          : Math.max(0, fullPrice - bestDiscount.amount);
  
        item.price = {
          price: discountPrice,
          original_price: fullPrice,
          discount_description: bestDiscount.line_label
        };
      });
    });
  
    return items;
}
  

function parseDepositBalance(section, sectionId) {
    const price = getSectionItemTotals(sectionId).total_price;
    const depositItemData = section.querySelector('script[data-deposit-item-json]');
    if (!depositItemData) return price;

    const depositProduct = JSON.parse(depositItemData.textContent);
    const depositPrice = depositProduct.price / 100;
    return price - depositPrice;  
}

async function initOfferCheckout(button, event) {
    event.preventDefault();
    button.disabled = true;
    button.textContent = 'Adding to Cart...';

    const sectionId = button.dataset.offerSectionId;
    const section = document.getElementById(sectionId);
    const selected = window.selectedItems?.[sectionId];

    if (!selected) {
        console.warn('No selected items for checkout.');
        return;
    }

    // Flatten items
    const items = ['primary', 'multiple_primary', 'accessories', 'gifts']
        .flatMap(key => (selected[key] || []).map(item => ({ ...item, key })))
        .map(({ id, quantity, key }) => {
            const base = { id, quantity };

            // Initialize properties only if needed
            base.properties = {};

            // Tag gift items
            if (key === 'gifts') {
                base.properties['_gift'] = true; 
            }

            // Tag primary items with bonus info
            if (key === 'primary' || key === 'multiple_primary') {
                base.properties.Includes = "Travel Bag + 4 Base Accessories";
            }

            // Example: Add conditional property based on variant ID
            if ([46212023484608, 46212025319616, '46212023484608', '46212025319616'].includes(id)) {
                base.properties.Includes = "Custom Extender Travel Bag";
            }

            // Remove properties object if still empty (optional)
            if (Object.keys(base.properties).length === 0) {
                delete base.properties;
            }

            return base;
        })
        .filter(item => item.quantity > 0);

    if (items.length === 0) {
        console.warn('No valid items to add to cart.');
        return;
    }

    const depositOnly = section.querySelector('input[type="radio"][data-deposit-only]:checked') ? true : false;

    const payload = depositOnly
        ? JSON.stringify({ 
            items: [
                {
                    id: 46534369804480,
                    quantity: 1,
                    properties: {
                        '_preorder_items': parseCustomDiscounts(items),
                        ...parseSummaryProperties(items),
                        "Free Shipping": "Within the USA 🎁",
                        "Remaining Balance": formatCurrency(parseDepositBalance(section, sectionId)),
                        "Deposit Refund Policy": "Deposits are fully refundable. Your item will not be shipped until the remaining balance has been paid."
                    }
                }
            ]
        })
        : JSON.stringify({ items });


    try {
        // Step 1: Clear the cart
        const clearRes = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!clearRes.ok) {
            throw new Error('Failed to clear cart');
        }

        // Step 2: Add items
        const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: payload
        });

        if (!addRes.ok) {
            const err = await addRes.json();
            console.error('Cart add failed:', err);
            alert('Something went wrong adding items to the cart. Please try again.');
            return;
        }

        // Step 3: Redirect to checkout
        window.location.href = '/checkout';
    } catch (error) {
        button.disabled = false;
        button.textContent = button.dataset.defaultText;
        console.error('Checkout error:', error);
        alert('There was a problem initiating checkout.');
    }
}

// CUSTOM COUNTDOWN BAR

(() => {
    const SELECTOR = '[data-component="countdown"]';
    const TIMEZONE = 'America/Los_Angeles';
  
    const formatLA = (dateStr) =>
      new Date(new Intl.DateTimeFormat('en-US', {
        timeZone: TIMEZONE,
        hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).format(new Date(dateStr)));
  
    const getTimeParts = (ms) => ({
      days:    Math.floor(ms / 86400000),
      hours:   Math.floor(ms % 86400000 / 3600000),
      minutes: Math.floor(ms % 3600000 / 60000),
      seconds: Math.floor(ms % 60000 / 1000)
    });
  
    const updateCountdown = (el, end) => {
      const now = formatLA(Date.now());
      const diff = end - now;
  
      if (diff <= 0) {
        el.closest('.op-countdown--wrapper')?.remove();
        return;
      }
  
      const { days, hours, minutes, seconds } = getTimeParts(diff);
  
      el.querySelector('[data-item="days"]').textContent    = String(days).padStart(2, '0');
      el.querySelector('[data-item="hours"]').textContent   = String(hours).padStart(2, '0');
      el.querySelector('[data-item="minutes"]').textContent = String(minutes).padStart(2, '0');
      el.querySelector('[data-item="seconds"]').textContent = String(seconds).padStart(2, '0');
    };
  
    const initCountdown = (el) => {
      const endAttr = el.dataset.end;
      if (!endAttr) return;
  
      const endTime = formatLA(endAttr);
      updateCountdown(el, endTime);
  
      const interval = setInterval(() => {
        if (!document.body.contains(el)) return clearInterval(interval);
        updateCountdown(el, endTime);
      }, 1000);
    };
  
    const initAllCountdowns = () => {
      document.querySelectorAll(SELECTOR).forEach(initCountdown);
    };
  
    document.addEventListener('DOMContentLoaded', initAllCountdowns);
    document.addEventListener('shopify:section:load', initAllCountdowns);
  })();
  
  // TOAST-STYLE SNACKBARS

  function throwNotice(message, heading = null, type = 'default', duration = 3000) {
    const notice = document.createElement('div');
    notice.className = `notice notice--${type}`;
    const headingContent = heading ? `<h3 class="mt0 mb0">${heading}</h3>` : '';
    const messageContent = message ? `<p class="mt1 mb0">${message}</p>` : '';
    notice.innerHTML = `${headingContent}${messageContent}`;

    document.body.appendChild(notice);

    // Trigger animation (allow reflow)
    requestAnimationFrame(() => {
        notice.classList.add('notice--visible');
    });

    // Auto-remove after duration
    setTimeout(() => {
        notice.classList.remove('notice--visible');
        notice.addEventListener('transitionend', () => notice.remove());
    }, duration);
}

async function highlightRequiredFields(target, event) {
    const sectionId = target.dataset.selectorFor;
    if (!sectionId) return;

    const section = document.getElementById(sectionId);
    if (!section) return;

    const input = section.querySelector('[name="offer-select-option"]')
    if (!input) return;

    const wrapper = input.closest('.op-radio--wrapper');
    if (!wrapper) return;

    if (!isInView(wrapper)) { 
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        await delay(500);
    };
    
    wrapper.classList.add('selection-required');

    await delay(900);
    wrapper.classList.remove('selection-required');
}

// async function handleFieldHighlight(field, index) {
//     let label = field.nextElementSibling.tagName === 'LABEL' ? field.nextElementSibling : document.querySelector(`label[for="${field.id}"]`);
//     if (!label) return;

//     if (index === 0) label.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
//     const content = label.querySelector('.op-radio--image') ? label.querySelector('.op-radio--image') : label;
//     content.style.opacity = 1;
//     content.style.transition = 'all 0.75s ease';

//     await new Promise(resolve => setTimeout(resolve, 750));
//     content.style.opacity = null
//     content.style.transition = null;





// }